/* SatisfyComfort theme — storefront behaviour. No dependencies.
The cart uses Shopify's AJAX cart API, so lines, totals and the automatic bundle
discount are Shopify's own. Built from site/assets/app.js by theme-v2/make_theme.py. */
(function () {
'use strict';
var PRICE = 7999; // cents; replaced by the product price on the product page
var root = document.documentElement;
var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
function $(sel, ctx) {
return (ctx || document).querySelector(sel);
}
function $$(sel, ctx) {
return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
}
var currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
function money(cents) {
return currency.format(cents / 100); // $1,799.30, not $1799.3
}
function rateFor(qty) {
return qty >= 3 ? 0.25 : qty === 2 ? 0.15 : 0;
}
function priceFor(qty) {
var sub = PRICE * qty;
return { sub: sub, total: (PRICE - Math.round(PRICE * rateFor(qty))) * qty, rate: rateFor(qty) };
}
/* ---------- Header ---------- */
function onScroll() {
root.classList.toggle('is-scrolled', window.scrollY > 8);
}
window.addEventListener('scroll', onScroll, { passive: true });
onScroll();
var menuBtn = $('[data-menu-toggle]');
var mobileNav = $('#mobile-nav');
if (menuBtn && mobileNav) {
menuBtn.addEventListener('click', function () {
var open = menuBtn.getAttribute('aria-expanded') !== 'true';
menuBtn.setAttribute('aria-expanded', String(open));
mobileNav.classList.toggle('is-open', open);
$$('a', mobileNav).forEach(function (a) {
a.tabIndex = open ? 0 : -1;
});
});
$$('a', mobileNav).forEach(function (a) {
a.tabIndex = -1;
a.addEventListener('click', function () {
menuBtn.click();
});
});
}
/* ---------- Scroll reveal (staggered, once) ---------- */
var revealEls = $$('[data-reveal]');
revealEls.forEach(function (el) {
Array.prototype.forEach.call(el.children, function (child, i) {
child.style.setProperty('--i', Math.min(i, 4));
});
});
if ('IntersectionObserver' in window && revealEls.length) {
var io = new IntersectionObserver(
function (entries) {
entries.forEach(function (e) {
if (!e.isIntersecting) return;
e.target.classList.add('is-in');
io.unobserve(e.target);
});
},
{ rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
);
revealEls.forEach(function (el) {
io.observe(el);
});
} else {
revealEls.forEach(function (el) {
el.classList.add('is-in');
});
}
/* ---------- Cart (Shopify AJAX API) ---------- */
var ROUTES = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
var MAX_PER_COLOR = 10;
var cart = { items: [], item_count: 0, total_price: 0, original_total_price: 0, total_discount: 0 };
try {
var initial = document.getElementById('cart-json');
if (initial) cart = JSON.parse(initial.textContent);
} catch (e) {}
function esc(s) {
return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
});
}
function api(path, body) {
return fetch(ROUTES + path, {
method: body ? 'POST' : 'GET',
headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
body: body ? JSON.stringify(body) : undefined,
}).then(function (r) {
return r.json().then(function (data) {
if (!r.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
return data;
});
});
}
function setCart(c) {
cart = c;
renderAll();
return c;
}
function refreshCart() {
return api('cart.js').then(setCart);
}
window.scRefreshCart = refreshCart;
function cartQty() {
return cart.item_count || 0;
}
function qtyOfVariant(id) {
return cart.items.reduce(function (n, i) { return n + (i.variant_id === id ? i.quantity : 0); }, 0);
}
function addVariant(id, qty) {
var allowed = Math.min(qty, MAX_PER_COLOR - qtyOfVariant(id));
if (allowed <= 0) return Promise.reject(new Error('Limit ' + MAX_PER_COLOR + ' per color. Need more? Email us.'));
return api('cart/add.js', { items: [{ id: id, quantity: allowed }] }).then(function () {
bumpCount();
return refreshCart();
});
}
var errorTimer;
function showCartError(err) {
var box = $('[data-cart-error]');
if (!box) return;
box.textContent = err && err.message ? err.message : 'Something went wrong. Please try again.';
box.hidden = false;
clearTimeout(errorTimer);
errorTimer = setTimeout(function () { box.hidden = true; }, 6000);
}
function changeLine(key, qty) {
return api('cart/change.js', { id: key, quantity: qty }).then(setCart).catch(function (err) {
showCartError(err);
renderAll();
});
}
function checkoutUrl() {
return ROUTES + 'checkout';
}
function bumpCount() {
var badge = $('[data-cart-count]');
if (!badge || reduceMotion.matches || !badge.animate) return;
badge.animate(
[{ transform: 'scale(1)' }, { transform: 'scale(1.15)' }, { transform: 'scale(1)' }],
{ duration: 240, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' }
);
}
function appliedCodes() {
var titles = [];
(cart.cart_level_discount_applications || []).forEach(function (a) {
if (a.type === 'discount_code' && titles.indexOf(a.title) < 0) titles.push(a.title);
});
cart.items.forEach(function (item) {
(item.line_level_discount_allocations || []).forEach(function (d) {
var a = d.discount_application;
if (a && a.type === 'discount_code' && titles.indexOf(a.title) < 0) titles.push(a.title);
});
});
return titles;
}
function cartMarkup() {
var qty = cartQty();
if (!qty) {
return (
'<div class="empty"><h3>Your cart is empty</h3>' +
'<p>One cushion, three colors. Free US shipping on every order.</p>' +
'<a class="btn" href="' + ROUTES + 'products/gel-seat-cushion">Shop the cushion <svg class="icon-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a></div>'
);
}
var codes = appliedCodes();
var tail = codes.length ? ' + code ' + esc(codes.join(', ')) : '';
var next = (qty === 1 ? 'Add 1 more to save 15%' : qty === 2 ? 'Add 1 more to save 25%' : 'You’re saving 25% on the bundle') + tail;
var fill = Math.min(qty / 3, 1);
var lines = cart.items
.map(function (item) {
var variant = item.variant_title || '';
var image = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
var atMax = qtyOfVariant(item.variant_id) >= MAX_PER_COLOR;
return (
'<li class="line" data-line="' + esc(item.key) + '">' +
'<div class="line__img">' + (image ? '<img src="' + esc(image) + '" alt="" width="84" height="84">' : '') + '</div>' +
'<div><div class="line__title">' + esc(item.product_title) + '</div><div class="line__variant">' + esc(variant) + '</div>' +
'<div class="qty" role="group" aria-label="Quantity for ' + esc(variant || item.product_title) + '">' +
'<button type="button" data-qty="' + esc(item.key) + '" data-step="-1" aria-label="Remove one">' +
'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg></button>' +
'<output aria-live="polite">' + item.quantity + '</output>' +
'<button type="button" data-qty="' + esc(item.key) + '" data-step="1" aria-label="Add one"' + (atMax ? ' disabled' : '') + '>' +
'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></button></div>' +
(atMax ? '<p class="qty-note">Limit ' + MAX_PER_COLOR + ' per color. Need more? Email us.</p>' : '') +
'<button type="button" class="line__remove" data-remove="' + esc(item.key) + '">Remove</button></div>' +
'<div class="line__price">' + money(item.final_line_price) + '</div></li>'
);
})
.join('');
return (
'<div class="nudge"><div>' + next + '</div><div class="nudge__bar" aria-hidden="true"><div class="nudge__fill" style="transform:scaleX(' + fill + ')"></div></div></div>' +
'<ul class="line-items">' + lines + '</ul>'
);
}
function totalsMarkup() {
var qty = cartQty();
if (!qty) return '';
var sub = cart.original_total_price;
var saved = cart.total_discount || 0;
var total = cart.total_price;
var rows = '<div><dt>Subtotal</dt><dd>' + money(sub) + '</dd></div>';
if (saved > 0) {
var bundleSaved = cart.items.reduce(function (n, item) { return n + (item.line_level_discount_allocations || []).reduce(function (m, d) { return m + (d.discount_application && d.discount_application.type === 'discount_code' ? 0 : d.amount); }, 0); }, 0);
var codeSaved = saved - bundleSaved;
if (bundleSaved > 0) rows += '<div class="is-save"><dt>Bundle savings</dt><dd>−' + money(bundleSaved) + '</dd></div>';
if (codeSaved > 0) rows += '<div class="is-save"><dt>' + (appliedCodes().length ? 'Code ' + esc(appliedCodes().join(', ')) : 'Discount') + '</dt><dd>−' + money(codeSaved) + '</dd></div>';
} else if (qty >= 2) {
var est = Math.round((sub / qty) * (qty >= 3 ? 0.25 : 0.15)) * qty;
rows += '<div class="is-save"><dt>Bundle savings (at checkout)</dt><dd>−' + money(est) + '</dd></div>';
total = sub - est;
}
rows += '<div><dt>Shipping</dt><dd>Free</dd></div>';
rows += '<div class="is-total"><dt>' + (saved > 0 || qty < 2 ? 'Total' : 'Estimated total') + '</dt><dd>' + money(total) + '</dd></div>';
return (
'<dl class="totals">' + rows + '</dl>' +
'<a class="btn btn--block btn--lg" href="' + checkoutUrl() + '">Checkout <svg class="icon-arrow" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>' +
'<p class="checkout-note">Secure checkout by Shopify. ' + (appliedCodes().length ? 'Your code and bundle savings both apply.' : 'Bundle savings are applied automatically.') + '</p>'
);
}
function nudgeScale(body) {
var bar = body.querySelector('.nudge__fill');
return bar ? new DOMMatrix(getComputedStyle(bar).transform).a : null;
}
function animateNudge(body, from, fill) {
var bar = body.querySelector('.nudge__fill');
if (!bar || !bar.animate || from === null || Math.abs(from - fill) < 0.001 || reduceMotion.matches) return;
bar.animate(
[{ transform: 'scaleX(' + from + ')' }, { transform: 'scaleX(' + fill + ')' }],
{ duration: 300, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' }
);
}
function renderAll() {
var qty = cartQty();
var badge = $('[data-cart-count]');
if (badge) {
badge.textContent = qty;
badge.hidden = qty === 0;
}
var cartBtn = $('[data-cart-open]');
if (cartBtn) cartBtn.setAttribute('aria-label', 'Cart, ' + qty + (qty === 1 ? ' item' : ' items'));
var fill = Math.min(qty / 3, 1);
$$('[data-cart-body]').forEach(function (el) {
var from = nudgeScale(el);
el.innerHTML = cartMarkup();
animateNudge(el, from, fill);
});
$$('[data-cart-foot]').forEach(function (el) {
el.innerHTML = totalsMarkup();
el.hidden = qty === 0;
});
}
document.addEventListener('click', function (e) {
var step = e.target.closest('[data-qty]');
if (step) {
if (step.disabled) return;
var key = step.getAttribute('data-qty');
var line = cart.items.find(function (l) { return l.key === key; });
if (!line) return;
var dir = Number(step.getAttribute('data-step'));
if (dir > 0 && qtyOfVariant(line.variant_id) >= MAX_PER_COLOR) return;
$$('[data-qty="' + key + '"]').forEach(function (b) { b.disabled = true; });
changeLine(key, Math.max(0, line.quantity + dir)).then(function () {
var again = $('[data-qty="' + key + '"][data-step="' + dir + '"]');
if (again && !again.disabled) again.focus();
});
return;
}
var rm = e.target.closest('[data-remove]');
if (rm && !rm.disabled) {
var removeKey = rm.getAttribute('data-remove');
var panel = rm.closest('.drawer__panel');
var li = rm.closest('.line');
rm.disabled = true;
if (li) li.classList.add('is-leaving');
setTimeout(function () {
changeLine(removeKey, 0).then(function () {
if (panel) $('.drawer__head [data-cart-close]', panel).focus();
});
}, li ? 180 : 0);
}
});
window.addEventListener('pageshow', function (e) {
if (e.persisted) refreshCart().catch(function () {});
});
/* ---------- Drawer ---------- */
var drawer = $('#cart-drawer');
var lastFocus = null;
function openDrawer() {
if (!drawer || drawer.classList.contains('is-open')) return;
lastFocus = document.activeElement;
drawer.classList.add('is-open');
drawer.setAttribute('aria-hidden', 'false');
$$('body > header, body > main, body > footer, body > .announce, body > .deal, body > .skip-link, body > .buybar').forEach(function (el) {
if (el.inert) return;
el.inert = true;
el.setAttribute('data-drawer-inert', '');
});
document.body.style.overflow = 'hidden';
setTimeout(function () {
$('.drawer__head [data-cart-close]', drawer).focus();
}, 30);
}
function closeDrawer() {
if (!drawer || !drawer.classList.contains('is-open')) return;
drawer.classList.remove('is-open');
drawer.setAttribute('aria-hidden', 'true');
$$('[data-drawer-inert]').forEach(function (el) {
el.inert = false;
el.removeAttribute('data-drawer-inert');
});
document.body.style.overflow = '';
if (lastFocus) lastFocus.focus();
}
$$('[data-cart-open]').forEach(function (b) {
b.addEventListener('click', function (e) {
if (!drawer) return;
e.preventDefault();
openDrawer();
});
});
if (drawer) {
$$('[data-cart-close]', drawer).forEach(function (b) {
b.addEventListener('click', closeDrawer);
});
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape') closeDrawer();
});
initDrawerDrag();
}
/* Drag to dismiss. Phones: the sheet follows the finger down from its handle/header.
Touch tablets: the side drawer follows a swipe to the right. The panel tracks 1:1,
resists past its open edge (rubber-band), and dismisses on distance or a flick. */
function initDrawerDrag() {
var panel = $('.drawer__panel', drawer);
var scrim = $('.drawer__scrim', drawer);
var sheetMq = window.matchMedia('(max-width: 599px)');
var drag = null;
function rubberband(over, size) {
var k = 0.55;
return (over * size * k) / (size + k * Math.abs(over));
}
panel.addEventListener('pointerdown', function (e) {
if (drag || e.button !== 0) return; // one pointer at a time
var sheet = sheetMq.matches;
if (sheet && !e.target.closest('[data-drawer-grab]')) return;
if (!sheet && e.pointerType === 'mouse') return;
drag = {
id: e.pointerId,
axis: sheet ? 'y' : 'x',
start: sheet ? e.clientY : e.clientX,
size: sheet ? panel.offsetHeight : panel.offsetWidth,
delta: 0,
active: false,
samples: [],
};
});
panel.addEventListener('pointermove', function (e) {
if (!drag || e.pointerId !== drag.id) return;
var pos = drag.axis === 'y' ? e.clientY : e.clientX;
var delta = pos - drag.start;
if (!drag.active) {
if (Math.abs(delta) < 8) return; // hysteresis: a tap stays a tap
if (delta < 0) {
drag = null; // only drags toward the closed edge start a dismiss
return;
}
drag.active = true;
var m = new DOMMatrix(getComputedStyle(panel).transform);
drag.offset = Math.max(0, drag.axis === 'y' ? m.m42 : m.m41);
drag.start = pos - drag.offset;
delta = drag.offset;
drawer.classList.add('is-dragging');
try {
panel.setPointerCapture(e.pointerId); // keep tracking if the finger leaves the panel
} catch (err) {}
}
drag.delta = delta;
drag.samples.push({ t: e.timeStamp, v: delta });
if (drag.samples.length > 5) drag.samples.shift();
var shown = delta >= 0 ? delta : rubberband(delta, drag.size);
panel.style.transform = drag.axis === 'y' ? 'translateY(' + shown + 'px)' : 'translateX(' + shown + 'px)';
scrim.style.opacity = String(Math.max(0, 1 - Math.max(0, delta) / drag.size));
});
function end(e) {
if (!drag || e.pointerId !== drag.id) return;
var d = drag;
drag = null;
if (!d.active) return;
var first = d.samples[0] || { t: 0, v: 0 };
var last = d.samples[d.samples.length - 1] || first;
var velocity = (last.v - first.v) / Math.max(1, last.t - first.t); // px per ms
var dismiss = d.delta > d.size * 0.3 || velocity > 0.11;
var remaining = dismiss ? Math.max(0, d.size - d.delta) : Math.max(0, d.delta);
var ms = Math.round(Math.min(260, Math.max(120, remaining / Math.max(Math.abs(velocity), 0.5))));
var settle = 'transform ' + ms + 'ms cubic-bezier(0.23, 1, 0.32, 1)';
panel.style.transition = settle;
scrim.style.transition = 'opacity ' + ms + 'ms ease';
drawer.classList.remove('is-dragging');
panel.style.transform = '';
scrim.style.opacity = '';
if (dismiss) closeDrawer();
var clear = function () {
panel.style.transition = '';
scrim.style.transition = '';
};
panel.addEventListener('transitionend', clear, { once: true });
setTimeout(clear, ms + 50); // in case transitionend never fires (reduced motion, no movement)
}
panel.addEventListener('pointerup', end);
panel.addEventListener('pointercancel', end);
}
/* ---------- Product page ---------- */
var pdp = $('[data-pdp]');
var state = { qty: 1, color: 'Black' };
function updateBuy() {
var p = priceFor(state.qty);
$$('[data-buy-price]').forEach(function (el) {
var next = money(p.total);
if (el.textContent === next) return;
el.textContent = next;
if (el.animate && !reduceMotion.matches) {
el.animate(
[{ opacity: 0.35, filter: 'blur(3px)' }, { opacity: 1, filter: 'blur(0)' }],
{ duration: 200, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' }
);
}
});
$$('[data-buy-was]').forEach(function (el) {
var was = money(Number(el.getAttribute('data-buy-was')) * state.qty);
if (el.lastChild.textContent === was) return;
el.lastChild.textContent = was;
if (el.animate && !reduceMotion.matches) {
el.animate(
[{ opacity: 0.35, filter: 'blur(3px)' }, { opacity: 1, filter: 'blur(0)' }],
{ duration: 200, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' }
);
}
});
var colorLabel = $('[data-color-label]');
if (colorLabel) colorLabel.textContent = state.color;
var meta = $('[data-buybar-meta]');
if (meta) {
meta.textContent =
(state.qty > 1 ? state.qty + ' cushions · ' : '') + state.color + ' · ' + money(p.total) + ' · Free shipping';
}
}
if (pdp) {
$$('input[name="quantity"]', pdp).forEach(function (r) {
r.addEventListener('change', function () {
state.qty = Number(r.value);
updateBuy();
});
});
$$('input[data-slot]', pdp).forEach(function (r) {
r.addEventListener('change', function () {
state.color = r.getAttribute('data-color');
updateBuy();
var slide = $('[data-color-slide="' + state.color + '"]');
if (slide) goTo(Number(slide.getAttribute('data-index')));
});
});
var addBtn = $('[data-add]', pdp);
var addForm = $('[data-add-form]', pdp);
var addError = $('[data-add-error]', pdp);
var doneTimer;
if (addForm && addForm.getAttribute('data-price')) PRICE = Number(addForm.getAttribute('data-price'));
var checkedQty = $('input[name="quantity"]:checked', pdp);
if (checkedQty) state.qty = Number(checkedQty.value);
var checkedColor = $('input[name="id"]:checked', pdp);
if (checkedColor) state.color = checkedColor.getAttribute('data-color');
function chosen() {
var picks = [];
for (var i = 1; i <= state.qty; i++) {
var input = $('input[data-slot="' + i + '"]:checked', pdp);
if (input) picks.push(input);
}
return picks;
}
function syncColors() {
var multi = state.qty > 1;
$$('[data-color-row]', pdp).forEach(function (row) {
row.hidden = Number(row.getAttribute('data-color-row')) > state.qty;
});
$$('[data-row-label]', pdp).forEach(function (l) { l.hidden = !multi; });
var title = $('[data-color-title]', pdp);
if (title) title.textContent = multi ? 'Colors' : 'Color';
var names = chosen().map(function (i) { return i.getAttribute('data-color'); });
var same = names.every(function (n) { return n === names[0]; });
state.color = same ? names[0] || state.color : 'Mixed colors';
updateBuy();
var label = $('[data-color-label]', pdp);
if (label) label.textContent = multi && !same ? names.join(' · ') : names[0] || '';
}
$$('input[name="quantity"], input[data-slot]', pdp).forEach(function (r) {
r.addEventListener('change', syncColors);
});
syncColors();
function addPicks(picks) {
var counts = {};
picks.forEach(function (i) { counts[i.value] = (counts[i.value] || 0) + 1; });
var items = [];
for (var id in counts) {
var room = MAX_PER_COLOR - qtyOfVariant(Number(id));
if (room < counts[id]) return Promise.reject(new Error('Limit ' + MAX_PER_COLOR + ' per color. Need more? Email us.'));
items.push({ id: Number(id), quantity: counts[id] });
}
return api('cart/add.js', { items: items }).then(function () {
bumpCount();
return refreshCart();
});
}
function add(btn) {
var picks = chosen();
if (!picks.length || !btn || btn.disabled) return;
btn.disabled = true;
if (addError) addError.hidden = true;
addPicks(picks)
.then(function () {
btn.classList.add('is-done');
clearTimeout(doneTimer);
doneTimer = setTimeout(function () {
btn.classList.remove('is-done');
}, 1400);
setTimeout(openDrawer, reduceMotion.matches ? 0 : 380);
})
.catch(function (err) {
if (addError) {
addError.textContent = err.message;
addError.hidden = false;
}
})
.then(function () {
btn.disabled = false;
});
}
if (addForm) {
addForm.addEventListener('submit', function (e) {
e.preventDefault();
add(addBtn);
});
}
$$('[data-buybar-add]').forEach(function (b) {
b.addEventListener('click', function () { add(b); });
});
/* Gallery: native scroll-snap does the swiping; JS keeps counter, thumbs and arrows in sync. */
var track = $('.gallery__track', pdp);
var slides = $$('.gallery__slide', pdp);
var thumbs = $$('.thumbs button', pdp);
var count = $('[data-gallery-count]', pdp);
var prev = $('.gallery__nav--prev', pdp);
var next = $('.gallery__nav--next', pdp);
var current = 0;
function setCurrent(i) {
current = i;
if (count) count.textContent = i + 1 + ' / ' + slides.length;
thumbs.forEach(function (t, n) {
t.setAttribute('aria-current', String(n === i));
});
if (prev) prev.disabled = i === 0;
if (next) next.disabled = i === slides.length - 1;
}
function goTo(i) {
i = Math.max(0, Math.min(slides.length - 1, i));
track.scrollTo({ left: track.clientWidth * i, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
setCurrent(i);
}
if (track) {
var raf;
track.addEventListener(
'scroll',
function () {
cancelAnimationFrame(raf);
raf = requestAnimationFrame(function () {
setCurrent(Math.round(track.scrollLeft / track.clientWidth));
});
},
{ passive: true }
);
thumbs.forEach(function (t, i) {
t.addEventListener('click', function () { goTo(i); });
});
if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
if (next) next.addEventListener('click', function () { goTo(current + 1); });
track.addEventListener('keydown', function (e) {
if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
});
setCurrent(0);
}
updateBuy();
}
/* Delivery estimate: processing 1–2 days + 1–3 weeks transit. */
var eta = $('[data-eta]');
if (eta) {
var fmt = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
var from = new Date();
var to = new Date();
from.setDate(from.getDate() + 9);
to.setDate(to.getDate() + 23);
eta.textContent = fmt.format(from) + ' – ' + fmt.format(to);
}
/* ---------- Floating buy bar ---------- */
var buybar = $('[data-buybar]');
var sentinel = $('[data-buybar-sentinel]');
var stopper = $('[data-buybar-stop]');
if (buybar && sentinel && 'IntersectionObserver' in window) {
var pastHero = false;
var atEnd = false;
var sync = function () {
var show = pastHero && !atEnd;
buybar.classList.toggle('is-visible', show);
buybar.inert = !show;
};
var first = true;
buybar.classList.add('buybar--instant');
new IntersectionObserver(function (entries) {
var e = entries[0];
pastHero = !e.isIntersecting && (!sentinel.closest('.hero') || e.boundingClientRect.top < 0);
sync();
if (first) {
first = false;
requestAnimationFrame(function () {
requestAnimationFrame(function () {
buybar.classList.remove('buybar--instant');
});
});
}
}).observe(sentinel);
if (stopper) {
new IntersectionObserver(function (entries) {
atEnd = entries[0].isIntersecting;
sync();
}).observe(stopper);
}
sync();
}
/* ---------- Foam vs gel explainer ---------- */
var sink = $('[data-sink]');
if (sink) {
if ('IntersectionObserver' in window) {
var sinkIo = new IntersectionObserver(
function (entries) {
if (!entries[0].isIntersecting) return;
sink.classList.add('is-playing');
sinkIo.disconnect();
},
{ threshold: 0.6 }
);
sinkIo.observe(sink);
} else {
sink.classList.add('is-playing');
}
}
/* ---------- Customer emails: read more ---------- */
$$('[data-email-more]').forEach(function (b) {
b.addEventListener('click', function () {
var card = b.closest('.email');
var open = card.classList.toggle('is-open');
b.setAttribute('aria-expanded', String(open));
b.textContent = open ? 'Show less' : 'Read the whole email';
});
});
/* ---------- FAQ filters ---------- */
var filters = $$('[data-filter]');
if (filters.length) {
filters.forEach(function (f) {
f.addEventListener('click', function () {
var cat = f.getAttribute('data-filter');
filters.forEach(function (o) {
o.setAttribute('aria-pressed', String(o === f));
});
$$('[data-cat]').forEach(function (d) {
d.classList.toggle('is-hidden', cat !== 'all' && d.getAttribute('data-cat') !== cat);
});
var status = $('[data-filter-status]');
if (status) {
var n = $$('[data-cat]:not(.is-hidden)').length;
status.textContent = n + ' questions shown';
}
});
});
}
/* ---------- Contact form (Shopify contact form; validate before it posts) ---------- */
var form = $('#contact-form');
if (form) {
form.addEventListener('submit', function (e) {
var ok = true;
[$('#c-email', form), $('#c-message', form)].forEach(function (input) {
if (!input) return;
var err = $('#' + input.id + '-error');
var bad = !input.value.trim() || (input.type === 'email' && !/^\S+@\S+\.\S+$/.test(input.value));
input.setAttribute('aria-invalid', String(bad));
if (err) err.hidden = !bad;
if (bad && ok) {
input.focus();
ok = false;
}
});
if (!ok) e.preventDefault();
});
}
/* ---------- Track order tabs ---------- */
var tabs = $$('[role="tab"]');
tabs.forEach(function (tab, i) {
tab.addEventListener('click', function () {
tabs.forEach(function (t) {
var on = t === tab;
t.setAttribute('aria-selected', String(on));
t.tabIndex = on ? 0 : -1;
$('#' + t.getAttribute('aria-controls')).hidden = !on;
});
});
tab.addEventListener('keydown', function (e) {
var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
if (!dir) return;
var n = tabs[(i + dir + tabs.length) % tabs.length];
n.focus();
n.click();
});
});
var trackForm = $('[data-track]');
if (trackForm) {
trackForm.addEventListener('submit', function (e) {
e.preventDefault();
var input = trackForm.elements.tracking;
var err = $('#tracking-error');
var v = input.value.trim();
input.setAttribute('aria-invalid', String(!v));
err.hidden = !!v;
if (!v) {
input.focus();
return;
}
window.open('https://t.17track.net/en#nums=' + encodeURIComponent(v), '_blank', 'noopener');
});
}
renderAll();
})();